<div fxLayout="row" fxLayoutGap="20px" *ngFor="let item of createRange(30)">
    <ngx-skeleton-loader class="w-100" count="1" [theme]="{
    height: '25px',
    'margin-bottom': '10px'
  }"></ngx-skeleton-loader>
    <ngx-skeleton-loader class="w-100" count="1" [theme]="{
    height: '25px',
    'margin-bottom': '10px'
  }"></ngx-skeleton-loader>

    <ngx-skeleton-loader class="w-100" count="1" [theme]="{
    height: '25px',
    'margin-bottom': '10px'
  }"></ngx-skeleton-loader>

    <ngx-skeleton-loader class="w-100" count="1" [theme]="{
    height: '25px',
    'margin-bottom': '10px'
  }"></ngx-skeleton-loader>
</div>